import { Check, Copy, Loader2 } from "lucide-react";
import { useEffect, useState } from "react";

import { anunciosMetaApi } from "./api";

import { linkAnuncioMeta } from "@/lib/linkAnuncioMeta";


/**
 * O link do cardápio que vai no anúncio, pronto para copiar. Dois jeitos:
 * turbinando pelo app (um campo só) e pelo Gerenciador de Anúncios (URL +
 * parâmetros, que é o que diz ao Núcleo QUAL campanha trouxe o pedido).
 * Se a loja ainda não tem o link "Anúncios Meta", ele nasce aqui.
 */
function Campo({ rotulo, valor, e2e }) {
  const [copiado, setCopiado] = useState(false);
  const copiar = () => {
    navigator.clipboard?.writeText(valor);
    setCopiado(true);
    setTimeout(() => setCopiado(false), 2000);
  };
  return (
    <div className="space-y-1 min-w-0">
      <p className="text-xs font-semibold">{rotulo}</p>
      <div className="flex items-center gap-2">
        <code className="flex-1 min-w-0 truncate rounded-lg bg-muted px-2.5 py-1.5 text-xs" data-e2e={e2e}>{valor}</code>
        <button onClick={copiar} title="Copiar"
          className={`inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1.5 text-xs shrink-0 transition-colors ${copiado ? "border-emerald-500 text-emerald-500" : "hover:border-primary"}`}>
          {copiado ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />} {copiado ? "Copiado" : "Copiar"}
        </button>
      </div>
    </div>
  );
}

export default function ComoUsarLink({ trackToken, contaNome }) {
  const [token, setToken] = useState(trackToken || null);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    if (token) return;
    anunciosMetaApi.gerarLink().then((r) => setToken(r.track_token)).catch(() => setErro(true));
  }, [token]);

  if (erro) return <p className="text-sm text-destructive">Não foi possível gerar o link agora. Abra Links de divulgação e tente por lá.</p>;
  if (!token) return <p className="text-sm text-muted-foreground inline-flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" /> Gerando o link…</p>;

  const link = linkAnuncioMeta(token);
  return (
    <div className="rounded-lg bg-muted/40 p-3 sm:p-4 space-y-4" data-e2e="meta-como-usar-link">
      <div className="space-y-2">
        <p className="text-sm font-semibold">Turbinando pelo Instagram ou pelo Facebook</p>
        <p className="text-xs text-muted-foreground">No botão do anúncio escolha <b>Site</b> e cole este link.</p>
        <Campo rotulo="Link do cardápio" valor={link.simples} e2e="meta-link-simples" />
      </div>
      <div className="space-y-2 border-t pt-4">
        <p className="text-sm font-semibold">Pelo Gerenciador de Anúncios</p>
        <p className="text-xs text-muted-foreground">
          No anúncio, em <b>Destino → Site</b>, cole a URL; em <b>Rastreamento → Parâmetros de URL</b>, cole os parâmetros.
          Assim o Núcleo sabe qual campanha e qual anúncio trouxeram cada pedido.
        </p>
        <div className="grid gap-3 sm:grid-cols-2">
          <Campo rotulo="URL do site" valor={link.url} e2e="meta-link-url" />
          <Campo rotulo="Parâmetros de URL" valor={link.parametros} e2e="meta-link-parametros" />
        </div>
      </div>
      <p className="text-[11px] text-muted-foreground">
        O pedido aparece marcado com qualquer um dos dois. Para o <b>gasto</b> aparecer aqui, o anúncio precisa
        rodar na conta conectada{contaNome ? <> (<b>{contaNome}</b>)</> : null}.
      </p>
    </div>
  );
}
